import { createFileRoute } from "@tanstack/react-router";
import { HubPage } from "@/components/HubPage";
import { residentialServices } from "@/data/site";

export const Route = createFileRoute("/residential/")({
  head: () => ({
    meta: [
      { title: "Residential Pressure Washing – Pompano Beach & Broward County" },
      { name: "description", content: "House washing, roof cleaning, driveways, gutters, windows, decks and more for homes across Broward County." },
      { name: "keywords", content: "residential pressure washing Broward, house washing Pompano Beach, roof soft wash Fort Lauderdale, driveway cleaning, gutter cleaning, deck cleaning, fence cleaning, Coastal Surface Experts" },
      { property: "og:title", content: "Residential Pressure Washing – Broward County" },
      { property: "og:description", content: "Soft wash and pressure washing for South Florida homes." },
      { property: "og:url", content: "https://mckay.steadyautogrowthdemo.com/residential" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/residential" }],
  }),
  component: () => (
    <HubPage
      category="residential"
      h1="Residential pressure washing for South Florida homes."
      intro="Soft wash for what matters, pressure where it belongs. Annual house washes, roof cleaning, driveways, decks, fences – the works. Locally owned, fully insured, on time."
      services={residentialServices}
    />
  ),
});
